/**
 * Confirm exchange — same confirmation shell as confirm-sale.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { SwapHoriz as SwapHorizIcon } from '@mui/icons-material';
import { ConfirmationModal } from '../../ui/Modal';

export interface ConfirmExchangeConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  /** True when any new line finalPrice is 0. */
  requiresZeroSaleAck?: boolean;
}

const ZERO_SALE_CHECKBOX_LABEL =
  'Confirmo que es un intercambio con ítem(s) en cero (cortesía / regalo).';

const ConfirmExchangeConfirmationModal: React.FC<ConfirmExchangeConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  requiresZeroSaleAck = false,
}): React.ReactElement => (
  <ConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    title="¿Confirmar este intercambio?"
    message="Se procesará el intercambio, se actualizará el inventario y se registrarán los pagos de la diferencia si aplica."
    confirmText="Confirmar"
    cancelText="Volver"
    variant={requiresZeroSaleAck ? 'warning' : 'default'}
    loading={loading}
    icon={<SwapHorizIcon />}
    requireCheckbox={requiresZeroSaleAck}
    checkboxLabel={requiresZeroSaleAck ? ZERO_SALE_CHECKBOX_LABEL : undefined}
    customContent={
      requiresZeroSaleAck ? (
        <Box>
          <Typography variant="body2" color="text.secondary">
            Este intercambio incluye ítem(s) en Bs 0.
          </Typography>
        </Box>
      ) : undefined
    }
  />
);

export default ConfirmExchangeConfirmationModal;
